import { Component } from '@theme/component';
import { QuantitySelectorUpdateEvent } from '@theme/events';

class SodPurchaseOptions extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('change', this.#sync);
    this.#sync();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#sync();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('change', this.#sync);
  }

  #sync = () => {
    const checked = this.querySelector('input[name="selling_plan"]:checked');
    const form = document.getElementById(this.dataset.formId ?? '');
    const button = form?.querySelector('[ref="addToCartButton"]');
    if (!checked || !button) return;

    // A plan like "3 every 3 months" ships 3 packs, so the cart line needs quantity 3.
    const quantity = form.querySelector('input[name="quantity"]');
    const packs = String(Number(checked.dataset.qty) || 1);
    if (quantity instanceof HTMLInputElement && quantity.value !== packs) {
      quantity.value = packs;
      quantity.dispatchEvent(new QuantitySelectorUpdateEvent(Number(packs)));
    }

    const label = checked.dataset.label;
    if (!label) return;

    const textNode = [...button.childNodes].find((n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim());
    if (textNode) textNode.textContent = ` ${label} `;
    else button.prepend(document.createTextNode(` ${label} `));
  };
}

if (!customElements.get('sod-purchase-options')) customElements.define('sod-purchase-options', SodPurchaseOptions);
